<template>
    <div>
        <Layout>
            <div v-if="!isLoading" class="col-lg-12">
                <button
                    type="button"
                    class="btn btn-common btn-common-delete btn-outline-danger position-absolute"
                    style="top: -46px; right: 1rem; z-index: 10"
                    @click="handleDeleteLP({ id: $route.query.id })"
                    v-if="checkPermission('landing_page.delete')"
                >
                    <i class="ri-delete-bin-2-line"></i>{{ $t('btn.delete') }}
                </button>
                <div class="card mb-0">
                    <div class="card-body" style="min-height: 100vh">
                        <b-tabs
                            v-model="modelTab"
                            vertical
                            justified
                            nav-class="nav-tabs-custom tabs_landing--page disabled"
                            content-class="p-3 text-muted"
                        >
                            <b-tab v-for="(tab, index) in TABS" :key="index" class="border-0" :disabled="tab.disabled">
                                <template v-slot:title>
                                    <span class="">{{ tab.name }}</span>
                                </template>
                                <div>
                                    <SettingBasicLP v-if="tab.id == 1" :dataForm="formData" />
                                    <SettingDesign v-else-if="tab.id == 2" :dataForm="formData" />
                                    <SettingBlocks v-else-if="tab.id == 3" :dataForm="formData" />
                                    <SettingFirstView v-else-if="tab.id == 4" :dataForm="formData" />
                                    <SettingTimeApplication v-else-if="tab.id == 5" :dataForm="formData" />
                                    <SettingPrizeList v-else-if="tab.id == 6" :dataForm="formData" />
                                    <SettingTargetProduct v-else-if="tab.id == 7" :dataForm="formData" />
                                    <SettingApplicationMethod v-else-if="tab.id == 8" :dataForm="formData" />
                                    <SettingReceiptPhotography v-else-if="tab.id == 9" :dataForm="formData" />
                                    <SettingApplicationRule v-else-if="tab.id == 10" :dataForm="formData" />
                                    <SettingContact v-else-if="tab.id == 11" :dataForm="formData" />
                                    <SettingShare v-else-if="tab.id == 12" :dataForm="formData" />
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                    <ModalSelectCampaignCopy
                        :config="configModalCommon"
                        :dataView="formData"
                        :masterCampaign="listDataMasterCampaign"
                        @copy="handleCopy"
                    />
                    <ModalListPreview
                        :formData="{ ...formData, forms: formData.campaign_forms, landing_pages: formData.campaign_lps }"
                        :config.sync="configModalListPrv"
                    />
                </div>
                <Footer>
                    <div style="display: grid; grid-template-columns: repeat(2, 1fr)">
                        <div class="d-flex align-items-center" style="gap: 0.7rem">
                            <button @click="handleCancel" class="btn btn-common-footer"><i class="ri-list-check"></i>{{ $t('btn.backList') }}</button>
                            <button type="button" class="btn btn-common-footer" @click="() => (configModalListPrv.model = true)">
                                <i class="ri-link-m"></i>{{ $t('pageCampaign.listLinkLPAndForm') }}
                            </button>
                        </div>
                        <div v-if="$route.query.id" class="text-right">
                            <button v-if="checkPermission('landing_page.register')" @click="onpenModalCP" class="btn btn-common-footer mr-2">
                                <i class="ri-file-copy-2-line"></i>{{ $t('btn.copy') }}
                            </button>
                            <button v-if="checkPermission('landing_page.edit')" @click="handleGoTo" class="btn btn-common btn-primary">
                                <i class="ri-edit-box-line"></i>{{ $t('btn.edit') }}
                            </button>
                        </div>
                    </div>
                </Footer>
            </div>
            <div class="d-flex justify-content-center" v-else>
                <LoadingIcon />
            </div>
        </Layout>
    </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import Footer from '@/components/Footer/main.vue';
import SettingBasicLP from './components/setting-basic/main.vue';
import SettingFirstView from './components/setting-first_view/main.vue';
import SettingPrizeList from './components/setting-prize/main.vue';
import SettingTargetProduct from './components/setting-target_product/main.vue';
import SettingDesign from './components/setting-design/main.vue';
import SettingBlocks from './components/setting-blocks/main.vue';
import SettingTimeApplication from './components/setting-time_application/main.vue';
import SettingApplicationMethod from './components/setting-application_method/main.vue';
import SettingReceiptPhotography from './components/setting-receipt_photography/main.vue';
import SettingApplicationRule from './components/setting-application_rule/main.vue';
import SettingShare from './components/setting-share/main.vue';
import SettingContact from './components/setting-contact/main.vue';
import LoadingIcon from '@/components/Loading/main.vue';
import ModalSelectCampaignCopy from './components/modal-select-campaign/main.vue';
import Swal from 'sweetalert2';
import moment from 'moment';
import ModalListPreview from '@/views/pages/campaign/view/components/ModalListPreview/main.vue';
import { checkPermission, getInfoUserLocalStorage } from '@/utils/handlers';

import { TABS, initFormRegister, configs } from '../constants';
import { masterMethods, landingPageMethods } from '@/state/helpers';
import { handleDataResponse, handleRecordLPError, handleDataBeforeSaveLP } from '../handlers';
import { showMessage } from '@/utils/messages';
import { isRolePartner } from '@/views/pages/require/handlers.js';

export default {
    name: 'ViewLandingPage',
    page: {
        title: 'キャンペーン一覧',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        Layout,
        Footer,
        LoadingIcon,
        SettingBasicLP,
        SettingFirstView,
        SettingPrizeList,
        SettingTargetProduct,
        SettingDesign,
        SettingBlocks,
        SettingTimeApplication,
        SettingApplicationMethod,
        SettingReceiptPhotography,
        SettingApplicationRule,
        SettingShare,
        SettingContact,
        ModalSelectCampaignCopy,
        ModalListPreview
    },
    data() {
        return {
            TABS: TABS(),
            formData: initFormRegister(),
            configModalListPrv: configs.configModalListPrv,
            modelTab: 0,
            isLoading: false,
            listDataMasterCampaign: [],
            configModalCommon: {
                title: '受注範囲',
                model: false,
                scrollable: true,
                hideFooter: false,
                size: 'lg',
                class: 'h-60'
            }
        };
    },
    methods: {
        checkPermission,
        ...masterMethods,
        ...landingPageMethods,

        handleCancel() {
            this.$router.push({
                path: '/landing-page/list'
            });
        },

        handleGoTo() {
            this.$router.push({
                path: '/landing-page/edit',
                query: {
                    id: this.$route.query.id
                }
            });
        },

        async handleCopy(newData) {
            this.formData = newData;
            let payload = handleDataBeforeSaveLP(this.formData);
            delete payload.id;
            payload.name = `${payload.name} Copy ${moment().format('YYYY/MM/DD HH:mm:ss')}`;
            payload.url_public = `${payload.url_public}-copy-${new Date().getTime()}`;
            this.isLoading = true;
            try {
                const dataRes = await this.copyLandingPage(payload);
                if (dataRes?.code !== 200) {
                    showMessage(dataRes?.code, this.$bvToast, dataRes?.message);
                    return;
                }
                this.$router.push({ path: '/landing-page/list' }).then(() => {
                    showMessage(dataRes?.code, this.$bvToast, 'LPが複製されました。');
                });
            } catch (error) {
                showMessage(error?.code, this.$bvToast, error?.message);
            } finally {
                this.isLoading = false;
            }
        },

        onpenModalCP() {
            this.configModalCommon.model = true;
        },

        async handleDeleteLP(payload) {
            Swal.fire({
                title: 'このLPを削除してもよろしいですか。',
                text: '',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#34c38f',
                cancelButtonColor: '#e8ecf4',
                cancelButtonText: 'キャンセル',
                confirmButtonText: 'OK'
            }).then(async (result) => {
                if (result.value) {
                    try {
                        const response = await this.deleteLandingPage(payload);
                        if (response.code !== 200) return;
                        this.$router.push({ path: '/landing-page/list' }).then(() => {
                            showMessage(response.code, this.$bvToast, 'LPが削除されました。');
                        });
                    } catch (error) {
                        console.log('error', error);
                    }
                }
            });
        },

        async getDetail() {
            if (!this.$route?.query?.id) return;
            this.isLoading = true;
            try {
                const response = await this.getDetailLandingPage(this.$route.query.id);
                if (!response?.campaign?.id) {
                    handleRecordLPError(this.$router, this.$route.query.id, this.$bvToast);
                    return;
                }
                handleDataResponse(this.formData, response, []);
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoading = false;
            }
        },

        async getMasterCampaign() {
            try {
                let query = 'all/campaigns';
                if (isRolePartner()) {
                    query += `?has[partner]=${getInfoUserLocalStorage().partner_id}`;
                }
                const dataRes = await this.listMaster(query);
                this.listDataMasterCampaign = dataRes;
            } catch (error) {
                console.log('error', error);
            }
        }
    },
    mounted() {
        this.getDetail();
        this.getMasterCampaign();
    }
};
</script>

<style lang="scss"></style>
